function Card(props) {
  const { variant, extra, children, ...rest } = props;
  return (
    <div
      className={`!z-5 relative flex flex-col rounded-[20px] !bg-navy-800 bg-clip-border text-white shadow-none shadow-shadow-500 ${extra}`}
      {...rest}
    >
      {children}
    </div>
  );
}

export default Card;
